var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    typography = _ref.typography,
    borders = _ref.borders,
    colors = _ref.colors;
  return {
    optionsInputMargin: spacing.small,
    optionsInputFontSize: typography.fontSizeSmall,
    optionsInputFontWeight: typography.fontWeightNormal,
    optionsInputBorderRadius: typography.radiusMedium,
    optionsInputConditionalMargin: spacing.xSmall,
    optionsInputPadding: spacing.xSmall,
    optionsInputBackgroundColor: colors.contrasts.white1010,
    optionsInputFocusColor: colors.contrasts.grey125125
  };
};
export default generateComponentTheme;